export const talentPlaylistsInitialState = {
  payload: ''
}

export type TalentPlaylistsState = typeof talentPlaylistsInitialState
